// eslint-disable-next-line import/no-anonymous-default-export
export default ({ request }) => ({
    getBriskConfig(params) {
        return request({
            url: 'admin/system/get_brisk_config',
            method: 'get',
            params,
        });
    },
    editBriskConfig(data) {
        return request({
            url: 'admin/system/edit_brisk_config',
            method: 'post',
            data,
        });
    },
});
